import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MainheaderComponent } from './layout/mainheader/mainheader.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { ContentComponent } from './layout/content/content.component';
import { LoginComponent } from './login/login.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import { routing } from './app.routing';
import {LoginService} from "./login/login.service";
import {AuthService} from "./auth.service";
import {UsermasterService} from "./usermaster/services/usermaster.service";
import { UserlistComponent } from './usermaster/userlist/userlist.component';
import { UserviewComponent } from './usermaster/userview/userview.component';
import { ResetPasswordComponent } from './usermaster/resetpassword/resetpassword.component';
import {CategoryService} from "./categoriesmaster/services/category.service";
import { CategorylistComponent } from './categoriesmaster/categorylist/categorylist.component';
import { CategoryviewComponent } from './categoriesmaster/categoryview/categoryview.component';
import { AddcategoryComponent } from './categoriesmaster/addcategory/addcategory.component';
import { CardService } from "./cardsmaster/services/card.service";
import { CardlistComponent } from './cardsmaster/cardlist/cardlist.component';
import { CardviewComponent } from './cardsmaster/cardview/cardview.component';
import { AddcardComponent } from './cardsmaster/addcard/addcard.component';
import { CardImagesService } from "./card_imagesmaster/services/card_images.service";
import { CardImageslistComponent } from './card_imagesmaster/card_imageslist/card_imageslist.component';
import { CardImagesviewComponent } from './card_imagesmaster/card_imagesview/card_imagesview.component';
import { AddcardImagesComponent } from './card_imagesmaster/addcard_images/addcard_images.component';
import { CardTextsService } from "./card_textsmaster/services/card_texts.service";
import { CardTextslistComponent } from './card_textsmaster/card_textslist/card_textslist.component';
import { CardTextsviewComponent } from './card_textsmaster/card_textsview/card_textsview.component';
import { AddcardTextsComponent } from './card_textsmaster/addcard_texts/addcard_texts.component';
import {EmailverifyComponent} from "./login/emailverify.component";
import {PagelistComponent} from "./pages/pagelist.component";
import {SortableColumnComponent} from "./sortable-table/sortable-column.component";
import {SortableTableDirective} from "./sortable-table/sortable-table.directive";
import {PageService} from "./pages/services/page.service";
import {HomeService} from "./home/home.service";
import {SortService} from "./sortable-table/sort.service";
import {PageviewComponent} from "./pages/pageview.component";
import {AdminviewComponent} from "./admin/adminview.component";
import {AddadminComponent} from "./admin/addadmin.component";
import {AddpageComponent} from "./pages/addpage.component";
import {AdminService} from "./admin/services/admin.service";
import {NgxPaginationModule} from 'ngx-pagination';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { CKEditorModule } from 'ng2-ckeditor';
import { LightboxModule } from 'angular2-lightbox';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainheaderComponent,
    SidebarComponent,
    ContentComponent,
    LoginComponent,
    UserlistComponent,
    UserviewComponent,
    EmailverifyComponent,
    PagelistComponent,
    PageviewComponent,
    AddpageComponent,
    SortableColumnComponent,
    SortableTableDirective,
    CategorylistComponent,
    CategoryviewComponent,
    CardlistComponent,
    CardviewComponent,
    CardImageslistComponent,
    CardImagesviewComponent,
    CardTextslistComponent,
    CardTextsviewComponent,
    AddcategoryComponent,
    AddcardComponent,
    AddcardImagesComponent,
    AddcardTextsComponent,
    ResetPasswordComponent,
    AddadminComponent,
    AdminviewComponent,
  ],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    Ng2SmartTableModule,
    CKEditorModule,
    LightboxModule,
  ],
  providers: [
      LoginService,
      AuthService,
      UsermasterService,
      PageService,
      HomeService,
      SortService,
      CategoryService,
      CardService,
      CardImagesService,
      CardTextsService,
      AdminService,
      {provide: LocationStrategy, useClass: HashLocationStrategy},
  ],
  bootstrap: [AppComponent,UserlistComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/app.module.ts